<template>
    <div>
        <nav-bar></nav-bar>
        <admin-landing></admin-landing>
    </div>
</template>

<script>
    import NavBar from '@/components/shared/NavBar.vue';
    import AdminLanding from '@/components/admin/AdminLanding.vue';

    export default {
        name: "Admin",
        components: {NavBar, AdminLanding}
    }
</script>

<style scoped>

</style>
